<template>
    <div class="todo-container">
    <div class="empty-todo-warning" v-show="filteredTodos.length < 1">
        No {{ (todoTypeProp !== 'All') ? todoTypeProp : '' }} todos
    </div>
      <draggable tag="div" v-bind="dragOptions">
        <transition-group name="fade">
            <TodoItem 
                v-for="(todo, i) in filteredTodos" 
                :key="todo.id" 
                :todo="todo"
                :todoList='todoList'
                @on-delete-btn-click="todoList.splice(i, 1)"
            >
            </TodoItem>
        </transition-group>
      </draggable>
      <TodoFooter 
          @clear-completed="$emit('clear-completed')"
          @active-todos="$emit('active-todos')"
          @all-todos="$emit('all-todos')"
          @completed-todos="$emit('completed-todos')"
      >
    </TodoFooter>
    </div>
</template>

<script>
import TodoItem from "./TodoItem.vue";
import TodoFooter from "./TodoListFooter.vue";
import draggable from 'vuedraggable';

export default {
    name: "TodoList",
    components: { TodoItem, TodoFooter, draggable },
    props: {
        todo: String,
        todoList: Array,
        enteredInput: String,
        todoCount: { type: Number }, // for future -> for smooth transition
        todoTypeProp: String,
    },
    data() {
        return {
            todoType: this.todoTypeProp
        }
    },
    computed: {
        // eslint-disable-next-line vue/return-in-computed-property
        filteredTodos: function() {
            if (this.todoTypeProp === 'All') {
                return this.todoList;
            } else if (this.todoTypeProp === 'Active') {
                return this.todoList.filter((todo) => {
                    if (!todo.isComplete) return todo
                })
            } else if (this.todoTypeProp === 'Completed') {
                return this.todoList.filter((todo) => {
                    if (todo.isComplete) return todo
                })
            }
        },
        dragOptions() {
            return {
                animation: 150,
                // easing: "cubic-bezier(1, 0, 0, 1)",
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
}
</script>

<style>
.todo-container {
    --todo-container-height: auto;

    height: var(--todo-container-height);
    border-radius: var(--border-radius);
    overflow: hidden;
    box-shadow: var(--todoList-shadow);
    background-color: var(--bg-todo-clr);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s, transform .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translate(-50%) scale(.6);
}

.ghost {
    background-color: var(--ghost-clr);
}

.empty-todo-warning {
    height: fit-content;
    background: var(--bg-todo-clr);
    color: rgb(141, 141, 141);
    width: 100%;
    padding: 15px 10px;
    text-align: center;
    border-bottom: solid 1px rgb(66, 66, 66);
    font-size: .9rem;
}

</style>
